import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-shared-overview',
    templateUrl: './shared-overview.component.html',
    styleUrls: ['./shared-overview.component.scss'],
})
export class SharedOverviewComponent implements OnInit {
    @Input() title: string;
    @Input() breadcrumb: string;
    @Input() image: string;

    constructor() {}

    ngOnInit(): void {
        this.breadcrumb = this.breadcrumb;
        this.image = this.image || '/assets/images/overview_img.png';
    }
}
